import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryReducer(state = initialState.forums, action) {
  if (action.type === types.LOAD_FORUM_DATA_SUCCESS) {
    return action.forums;
  }
  return state;
}
